/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';
import { CustomerDetails, DownloadStatus } from 'src/app/models/customer-details.model';

/** CustomerDetailsActionTypes */
export enum CustomerDetailsActionTypes {
    SET_CUSTOMER_DETAILS = 'SET_CUSTOMER_DETAILS',
    CHOSSE_REASON = 'CHOSSE_REASON',
    RESET_SELECTION = 'RESET_SELECTION',
    SET_XCONNERSATION_ID = 'SET_XCONNERSATION_ID',
    DOWNLOAD_STATUS = 'DOWNLOAD_STATUS',
    RESET_DOWNLOAD_STATUS = 'RESET_DOWNLOAD_STATUS',
    ACCOUNT_AGENT_STATUS = 'ACCOUNT_AGENT_STATUS',
}

/** SetCustomerDetails Action */
export class SetCustomerDetails implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.SET_CUSTOMER_DETAILS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** customerDetails */
        customerDetails: CustomerDetails,
    }) { }
}

/** Select Reason Action for Termination */
export class SetChooseReason implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.CHOSSE_REASON;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** cancellationReason */
        cancellationReason?: string,
    }) { }
}

/** Set XConversationId header */
export class SetXConversationId implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.SET_XCONNERSATION_ID;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** xConversationId */
        xConversationId?: string,
    }) { }
}

/** Reset Action to Reset state */
export class ResetSelection implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.RESET_SELECTION;
}

/** Select dowload status qr-code or label only */
export class SetDownloadStatus implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.DOWNLOAD_STATUS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** cancellationReason */
        downloadedStatus: DownloadStatus,
    }) { }
}

/** Reset Action to Reset download status */
export class ResetDownloadStatus implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.RESET_DOWNLOAD_STATUS;
}
/** Select account agent in case of termination 'directed from assisted termination'*/
export class SetAccountAgentStatus implements Action {

    /** type */
    public readonly type = CustomerDetailsActionTypes.ACCOUNT_AGENT_STATUS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** isAccountAgent */
        isAccountAgent: boolean,
    }) { }
}

/** CustomerDetailsAction */
export type CustomerDetailsAction =  SetCustomerDetails | SetChooseReason | ResetSelection | SetXConversationId | SetDownloadStatus | ResetDownloadStatus | SetAccountAgentStatus;
